export default class TransferQuestionnaireOwnershipController {
  constructor($scope, questionnaire, transferOwnership, people, close) {
    this.$scope = $scope;
    this.questionnaire = questionnaire;
    this.transferOwnership = transferOwnership;
    this.people = people;
    this.close = close;
  }


}